import type { OrderStatus } from '@/types';

/**
 * Explicit order lifecycle (PRD: Pending -> Paid -> Shipped -> Delivered / Cancelled, plus the agreed
 * PROCESSING and REFUNDED extensions). Arbitrary jumps are rejected. The server must own this same map.
 */
export const ORDER_TRANSITIONS: Record<OrderStatus, OrderStatus[]> = {
  PENDING: ['PAID', 'CANCELLED'],
  CONFIRMED: ['PAID', 'CANCELLED'], // legacy state, kept for compatibility
  PAID: ['PROCESSING', 'SHIPPED', 'CANCELLED'],
  PROCESSING: ['SHIPPED', 'CANCELLED'],
  SHIPPED: ['DELIVERED'],
  DELIVERED: ['REFUNDED'],
  CANCELLED: [],
  REFUNDED: [],
};

export const nextStatuses = (s: OrderStatus) => ORDER_TRANSITIONS[s];
export const canTransition = (from: OrderStatus, to: OrderStatus) => ORDER_TRANSITIONS[from].includes(to);

/** Transitions that need extra input in the UI (and validation in the service). */
export const TRANSITION_NEEDS: Partial<Record<OrderStatus, 'tracking' | 'reason'>> = {
  SHIPPED: 'tracking', CANCELLED: 'reason', REFUNDED: 'reason',
};

export const isFinalStatus = (s: OrderStatus) => ORDER_TRANSITIONS[s].length === 0;
